// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div class="brand-container">

    <div class="brand" v-if="collapsed">
      <img
      :style="{
        width: $config.theme['@mini-logo-width'],
        height: $config.theme['@mini-logo-height']
      }"
      :src="$config.minilogoInverted" />
    </div>
    <div class="brand" v-else-if="$config.logo">
      <img
      :style="{
        width: $config.theme['@logo-width'],
        height: $config.theme['@logo-height']
      }"
      :src="$config.logoInverted" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Logo',
  components: {
  },
  props: {
    title: {
      type: String,
      default: 'Linube Cloud',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    },
    collapsed: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>
<style scoped>
.ant-layout-sider-collapsed .brand-container {
  width: 80px !important;
} 
.brand-container {
  position:fixed;
  top: 0px;
  width: 256px;
  height: 60px;
  z-index: 50;
}
.brand {
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2) !important;
  background-color: #4c5559 !important;
  z-index: 100;
}
</style>